import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProjectTaskDialogTabs} from '../project-task-dialog-constants';

@Component({
  selector: 'projects-task-default-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './projects-task-default-tabs.component.html',
  styleUrl: './projects-task-default-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskDefaultTabsComponent implements OnInit, OnChanges {
  @Input() selectedTab!: string;
  @Input() triggerCount = 0;
  @Input() subtaskCount = 0;
  @Input() template = false;

  @Output() tabChange = new EventEmitter<string>();

  tabs: string[] = [];

  // Expose constants for template use
  readonly ProjectTaskDialogTabs = ProjectTaskDialogTabs;

  ngOnInit() {
    this.updateTabs();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['template']) {
      this.updateTabs();
    }
  }

  private updateTabs() {
    this.tabs = this.template
      ? [ProjectTaskDialogTabs.Details, ProjectTaskDialogTabs.Subtasks]
      : [ProjectTaskDialogTabs.Details, ProjectTaskDialogTabs.Schedule, ProjectTaskDialogTabs.Subtasks];
  }

  onTabClick(tab: string): void {
    this.tabChange.emit(tab);
  }

  // Helper method to get count for tabs
  getTabCount(tab: string): number {
    switch (tab) {
      case ProjectTaskDialogTabs.Subtasks:
        return this.subtaskCount;
      case ProjectTaskDialogTabs.Triggers:
        return this.triggerCount;
      default:
        return 0;
    }
  }

  // Helper method to check if tab should show count
  shouldShowCount(tab: string): boolean {
    return tab === ProjectTaskDialogTabs.Subtasks || tab === ProjectTaskDialogTabs.Triggers;
  }
}
